// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__FCGZc","content":"LayoutSettings_content__2l656"};